import React from 'react';

import {Types} from '@wheeebo/polaris-api';

const DEFAULT_RADAR_RADIUS = 3000; // meters.

interface LocationWithHeading extends Types.VehiclePath {
  coords: google.maps.LatLngLiteral;
  heading?: number;
  loadTime?: Date;
}

interface MonitorMapContextProps {
  vehicles?: Types.VehiclePath[];
  setVehicles?: (vehicles: Types.VehiclePath[]) => void;
  radarRadius: number;
  setRadarRadius?: (radius: number) => void;
  selectedVehicleId?: Types.UUID;
  setSelectedVehicleId?: (id: Types.UUID) => void;
  showFootprint: boolean;
  setShowFootprint?: (enabled: boolean) => void;
  showRadar: boolean;
  setShowRadar?: (enabled: boolean) => void;
  showFlightPath: boolean;
  setShowFlightPath?: (enabled: boolean) => void;
  showGeoFence: boolean;
  setShowGeoFence?: (enabled: boolean) => void;
  showSafePort: boolean;
  setShowSafePort?: (enabled: boolean) => void;
  showNoFlyZone: boolean;
  setShowNoFlyZone?: (enabled: boolean) => void;
}

const MonitorMapContext = React.createContext<MonitorMapContextProps>({
  vehicles: undefined,
  setVehicles: undefined,
  radarRadius: DEFAULT_RADAR_RADIUS,
  setRadarRadius: undefined,
  selectedVehicleId: undefined,
  setSelectedVehicleId: undefined,
  showFootprint: true,
  setShowFootprint: undefined,
  showRadar: true,
  setShowRadar: undefined,
  showFlightPath: true,
  setShowFlightPath: undefined,
  showGeoFence: true,
  setShowGeoFence: undefined,
  showSafePort: true,
  setShowSafePort: undefined,
  showNoFlyZone: true,
  setShowNoFlyZone: undefined,
});

interface Props {
  children: React.ReactNode;
}

function MonitorMapProvider({children}: Props): JSX.Element {
  const [vehicles, setVehicles] = React.useState<Types.VehiclePath[]>();
  const [radarRadius, setRadarRadius] = React.useState<number>(DEFAULT_RADAR_RADIUS);
  const [selectedVehicleId, setSelectedVehicleId] = React.useState<Types.UUID>();
  const [showFootprint, setShowFootprint] = React.useState(true);
  const [showRadar, setShowRadar] = React.useState(true);
  const [showFlightPath, setShowFlightPath] = React.useState(true);
  const [showGeoFence, setShowGeoFence] = React.useState(true);
  const [showSafePort, setShowSafePort] = React.useState(true);
  const [showNoFlyZone, setShowNoFlyZone] = React.useState(true);
  const provided = {
    vehicles,
    setVehicles,
    radarRadius,
    setRadarRadius,
    selectedVehicleId,
    setSelectedVehicleId,
    showFootprint,
    setShowFootprint,
    showRadar,
    setShowRadar,
    showFlightPath,
    setShowFlightPath,
    showGeoFence,
    setShowGeoFence,
    showSafePort,
    setShowSafePort,
    showNoFlyZone,
    setShowNoFlyZone,
  };
  return <MonitorMapContext.Provider value={provided}>{children}</MonitorMapContext.Provider>;
}

export {MonitorMapContext, MonitorMapProvider};

export type {LocationWithHeading, MonitorMapContextProps};
